import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { UserStatusService } from '../header/statistics-dropdown/user-status.service';

@Component({
    selector: 'app-profile-avatar',
    templateUrl: './profile-avatar.component.html',
    styleUrls: ['./profile-avatar.component.scss'],
    standalone: false
})
export class ProfileAvatarComponent implements OnInit {
  @Input() fullName: string = '';
  @Input() profileUrl: string = '';
  @Input() widthSize: string = '45px';
  @Input() heightSize: string = '45px';
  @Input() userStatusSlug: any | null = null;

  private previousStatusSlug: string | null = null;

  public statusSvg: SafeHtml | undefined;
  public statusTitle: string | undefined;

  constructor(
    public userStatusService: UserStatusService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    // this.previousStatusSlug = this.userStatusSlug?.slug || null;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // React to status slug changes
    if (changes['userStatusSlug']) {
      const currentSlug = this.userStatusSlug || null;
      const isStatusChanged = currentSlug !== this.previousStatusSlug;

      if (isStatusChanged) {
        this.previousStatusSlug = currentSlug;
        this.updateStatusInfo();
      }
    }
  }

  private updateStatusInfo(): void {
    const status = this.userStatusService?.getStatusBySlug(
      this.previousStatusSlug
    );

    if (status?.profileShownSvg) {
      this.statusSvg = this.sanitizer.bypassSecurityTrustHtml(status.profileShownSvg);
    } else {
      this.statusSvg = undefined;
    }
    this.statusTitle = status?.title;
  }

  get initials(): string {
    if (!this.fullName) return '';

    return this.fullName
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  }

  get dynamicFontSize(): string {
    const baseSize = 18;
    const referenceSize = 45;

    const width = parseInt(this.computedWidth, 10) || referenceSize;
    return `${(baseSize * width) / referenceSize}px`;
  }

  get computedWidth(): string {
    return this.widthSize || '45px';
  }

  get computedHeight(): string {
    return this.heightSize || '45px';
  }
}
